import React from 'react';
import { WidgetSettings } from 'types';

import { CollectionAsset } from '@kaltura-ott/tvpil-shared';

import DynamicGridViewer from 'components/pages/Grids/DynamicGridViewer/DynamicGridViewer';
import CollectionCardContainer from 'components/widgets/CardView/Collection/CollectionCardContainer/CollectionCardContainer';
import { WidgetProviderData } from 'context/widgetProvider/types';
import WidgetProvider from 'context/widgetProvider/widgetProvider';

interface Props {
  type: string;
  settings: WidgetSettings;
  gridData: WidgetProviderData<CollectionAsset>;
}

function CollectionGridLogic({ type, settings, gridData }: Props) {
  return (
    <WidgetProvider<CollectionAsset> type={type} isGrid settings={settings} data={gridData}>
      <DynamicGridViewer<CollectionAsset>>
        {({ imageHeight, itemWidth, data }) => (
          <CollectionCardContainer imageHeight={imageHeight} itemWidth={itemWidth} data={data} />
        )}
      </DynamicGridViewer>
    </WidgetProvider>
  );
}

export { CollectionGridLogic };
